import { UserContactsTypes } from './types';

export const getUserContacts = (clientId: number) => ({
  types: [
    UserContactsTypes.GET_USER_CONTACTS_REQUEST,
    UserContactsTypes.GET_USER_CONTACTS_SUCCESS,
    UserContactsTypes.GET_USER_CONTACTS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/boletim_web/base/contacts_clients.json?client_id=${clientId}`),
});
